import { createId } from '@/shared/lib/id/createId';
const sessions = new Map();
/**
 * 保存本次输入，仅通过可序列化的会话键连接入口和全局配置弹窗。
 *
 * 会话键统一走 createId()：它兼容普通 HTTP / 局域网 IP 这类非安全上下文，
 * 避免测试环境缺少 crypto.randomUUID 时整个「创建项目」流程被中断。
 */
export function stageCreationSession(session) {
    const key = createId();
    sessions.set(key, { ...session, requestKey: createId(), uploadedFiles: new Set() });
    return key;
}
/** 获取当前创建会话。 */
export function readCreationSession(key, ownerId) {
    const session = key ? sessions.get(key) : undefined;
    return session && (ownerId === undefined || session.ownerId === ownerId) ? session : undefined;
}
/** 正式创建成功后释放文件引用。 */
export function releaseCreationSession(key) {
    sessions.delete(key);
}
